var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeStyleProductNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9891 19.2691L4.71288 12.5387C0.747338 8.55495 6.53192 0.842174 11.9891 7.08152C17.4462 0.860369 23.2854 8.57315 19.2653 12.5387L11.9891 19.2691Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32031 11.6687H9.37656L10.7614 9.0249L12.8596 13.8928L14.6641 11.6687H16.6783",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStyleProductNew);
export default __webpack_public_path__ + "static/media/LifeStyleProductNew.c7a17a7fa748c3d4bdb094988441816d.svg";
export { ForwardRef as ReactComponent };